import * as React from 'react';

import { cn } from '@/lib/utils';

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'c-textarea ' +
          ' flex min-h-[100px] w-full rounded-md border border-primary-lightest bg-background px-3 py-2 text-base text-neutral ring-offset-background placeholder:text-muted-foreground md:text-sm' +
          ' hover:border-neutral-light hover:bg-bright hover:text-neutral-dark' +
          ' focus-visible:border-neutral-dark focus-visible:text-neutral-dark focus-visible:outline-none' +
          ' disabled:cursor-not-allowed disabled:opacity-50' +
          ' transition-colors duration-150',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
